<template>
  <div class="group_management" v-show="managementVisible">
    <!-- 创建分组弹窗 -->
    <create-group
      :createdGroupVisible="createdGroupVisible"
      @groupClose="groupClose"
      @groupKeyUp="groupKeyUp($event)"
      @creatGroup="creatGroup(manageData)"
    ></create-group>
    <h1>分组管理</h1>
    <img :src="close" alt="关闭" @click="closeManagementClick()" />
    <div class="groupList">
      <div
        v-for="(manageDataItem, index) in manageData.manageList"
        :key="index"
      >
        <tree-popup
          :showSubdirectories="showSubdirectories"
          :treeData="manageDataItem"
          @treeGetData="treeGetData"
        ></tree-popup>
      </div>
    </div>
    <div class="groupHandle">
      <span
        v-for="(handel, index) in handel"
        :key="index"
        @click.self="handleClick(handel, index, manageData.manageElement)"
      >
        {{ handel }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "groupManagement",
  data() {
    return {
      close: require("@/common/assets/close.png"),
      unchecked: require("@/common/assets/unchecked.png"),
      getCheckList: {},
      createdGroupVisible: false,
      accessToken: "",
      groupKw: "",
      showSubdirectories: 0, // 子分组是否显示
    };
  },
  created() {
    // 保存taoken
    let info = JSON.parse(localStorage.getItem("userInfo"));
    if (info) {
      this.accessToken = info.accessToken;
    }
  },
  props: {
    managementVisible: {
      type: Boolean,
      default: false,
    },
    manageData: {
      type: Object,
      default: () => {},
    },
    handel: {
      type: Array,
      default: ["创建分组", "删除"],
    },
  },
  methods: {
    treeGetData(val) {
      this.getCheckList = val;
      // console.log(this.getCheckList);
    },
    closeManagementClick() {
      this.$emit("closeManagementClick");
    },
    groupClose() {
      this.createdGroupVisible = !this.createdGroupVisible;
    },
    groupKeyUp(e) {
      this.groupKw = e.target.value;
    },
    creatGroup(manageData) {
      this.$http.axiosFun(
        this.$api.myFollow.group_add,
        {
          name: this.groupKw,
        },
        (res) => {
          if (res.error_code == 0) {
            this.createdGroupVisible = !this.createdGroupVisible;
            // console.log(manageData)
            // 添加之后进行渲染
            this.$http.axiosFun(
              this.$api.search.group_list_ext,
              {},
              (res) => {
                if (res.error_code == 0) {
                  this.manageData = {
                    manageElement: manageData.manageElement,
                    manageList: res.data,
                  };
                  // console.log(this.manageData);
                }
              },
              {
                accessToken: this.accessToken,
              }
            );
            this.$my_message.install({
              text: `创建成功`,
              type: "success",
            });
          }
        }
      );
    },
    handleClick(item, index, manageData) {
      switch (index) {
        case 0:
          // console.log(manageData)
          // 添加收藏
          if ( this.getCheckList.treeData && this.getCheckList.treeData != null ) {
            // 添加收藏
            this.$http.axiosFun(
              this.$api.search.favorite_add,
              {
                group_id: this.getCheckList.treeData.id,
                mids: manageData.mid,
              },
              (res) => {
                if (res.error_code == 0) {
                  this.manageData.manageList.forEach((item) => {
                    item.checkAll = false;
                  });
                  //   判断需要添加到的数组在哪里
                  let targetIndex = this.manageData.manageList.indexOf(
                    this.getCheckList.treeData
                  );
                  // 将获取的公众号添加到需要添加的分组里
                  this.manageData.manageList[targetIndex].account_list.push(
                    manageData
                  );
                  this.$my_message.install({
                    text: `添加成功`,
                    type: "success",
                  });
                  // 回调出处理函数
                  this.$emit("groupCallBack", manageData);
                } else if (res.error_code == 40005) {
                  this.$my_message.install({
                    text: `公众号已在分组中`,
                    type: "warning",
                  });
                }
              }
            );
          } else {
            this.$my_message.install({
              text: "请选择你想要的组或公众号，再进行添加收藏操作",
              type: "error",
            });
          }
          break;
        case 1:
          // 删除
          this.$http.axiosFun(
            this.$api.handle_group.group_delete,
            {
              group_id: this.getCheckList.treeData.id,
            },
            (res) => {
              if (res.error_code == 0) {
                this.$my_message.install({
                  text: `“${this.getCheckList.treeData.name}”，删除成功！`,
                  type: "success",
                });
                // 删除之后进行渲染
                this.$http.axiosFun(
                  this.$api.search.group_list_ext,
                  {},
                  (res) => {
                    if (res.error_code == 0) {
                      res.data.forEach((item) => {
                        item.checkAll = false;
                      });
                      //   console.log(this.manageData)
                      this.manageData = {
                        manageElement: manageData,
                        manageList: res.data,
                      };
                    }
                  },
                  {
                    accessToken: this.accessToken,
                  }
                );
              }
            },
            {
              accessToken: this.accessToken,
            }
          );
          break;
        case 2:
          // 新建分组
          this.createdGroupVisible = true;
          break;
        case 3:
          // console.log(this.getCheckList);
          // 置顶
          if ( this.getCheckList.treeData && this.getCheckList.treeData != null ) {
            // 添加收藏
            this.$http.axiosFun(
              this.$api.handle_group.group_top,
              {
                group_id: this.getCheckList.treeData.id,
              },
              (res) => {
                // console.log(res)
              }
            );
          } else {
            this.$my_message.install({
              text: "请选择你想要的组或公众号，再进行添加收藏操作",
              type: "error",
            });
          }
          break;
      }
    },
  },
};
</script>

<style lang="less" scpoed>
ul,
li {
  text-decoration: none;
}
.group_management {
  width: 540px;
  height: 700px;
  border-radius: 8px;
  background-color: #fff;
  // margin-left: calc(100% / 2 - 540px / 2);
  // margin-top: 180px;
  position: fixed;
  z-index: 1002;
  box-shadow: 1px 1px 10px #3e3e3e;
  .groupList {
    width: 100%;
    height: 70%;
    overflow-x: hidden;
    // border: solid 1px;
    box-sizing: border-box;
  }
}
.group_management > h1 {
  width: 100%;
  height: 90px;
  box-sizing: border-box;
  border: solid 1px #ccc;
  border-top: none;
  border-left: none;
  border-right: none;
  font-size: 26px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 600;
  line-height: 90px;
  text-align: center;
  color: #000000;
}
.group_management > img {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}
.groupHandle {
  cursor: pointer;
  width: 100%;
  //   border: solid 1px;
  height: 60px;
  font-size: 20px;
  line-height: 60px;
  color: #21a0ff;
  span {
    margin-left: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/group-management.vue